import React from 'react';
import env from '@lib/envs/env';
import { IStyleQuizQuestion } from '@graphql/StyleQuiz/queries/get-style-quiz-question.graphql';
import DefaultTemplate from '@components/shared/templates/DefaultTemplate/DefaultTemplate';

import withNextQuestion from '@components/shared/questions/utils/withNextQuestion';
import RoomSelection from './RoomSelection/RoomSelection';

interface IProps {
  question: IStyleQuizQuestion;
}

export default function StyleQuizRoomSelection({
  question,
}: IProps) {
  const metaData = getMetaData();

  return (
    <DefaultTemplate
      fullscreen
      canonicalLink={`https://${env.DOMAIN_NAME}/interior-design-style-quiz`}
      isNavVisible={false}
      isFooterVisible={false}
      title={metaData.title}
      description={metaData.description}
      facebook={metaData}
      noIndex
      noFollow
    >
      <RoomSelection
        question={withNextQuestion(question)}
        showMultiSelectCounters
      />
    </DefaultTemplate>
  );
}

function getMetaData() {
  return {
    site_name: 'Havenly',
    image: 'https://s3.amazonaws.com/havenlywebsite/havenly_meta_image.jpg',
    url: 'https://havenly.com/interior-design-style-quiz/room-selection',
    type: 'article',
    title: 'Interior Design Style Quiz | Decorating Style Quiz | Havenly',
    description: 'Find your interior design style with Havenly’s fun quiz. Take the decorating style quiz to reveal your design style, so you can start decorating your dream home!',
    price_amount: undefined,
    price_currency: undefined,
  };
}
